export default __webpack_public_path__ + "static/media/abc_der_tiere.004c164f.jpg";